import { useSelector } from 'react-redux';
import { UserTeamPermission } from 'types/user';

import { appMetaSelectors } from '../../../store/modules/appMeta';
import { userSelectors } from '../../../store/modules/user';

type ProjectPermissions = Pick<UserTeamPermission, 'canCreateProject' | 'canEditProject' | 'canViewProject'> & {
  canMoveToWorkspace: boolean;
};
const defaultPermissions: ProjectPermissions = {
  canMoveToWorkspace: true,
  canCreateProject: true,
  canEditProject: true,
  canViewProject: true
};

const useProjectsPermissions = (): ProjectPermissions => {
  const hasTeamAccess = useSelector(userSelectors.selectTeamAccess);

  const workspace = useSelector(appMetaSelectors.selectWorkspace);
  const permissions = useSelector(userSelectors.selectTeamPermissions);

  return workspace === 'user' || !permissions
    ? { ...defaultPermissions, canMoveToWorkspace: hasTeamAccess && !!permissions?.canCreateProject }
    : { ...permissions, canMoveToWorkspace: permissions.canCreateProject };
};

export default useProjectsPermissions;
